<div class="dialog">
  <app-dialog-header>
    {{ "GENERALS.ADD-PROVIDER" | translate }}
  </app-dialog-header>

  <div class="dialog-body">
    <form
      [formGroup]="providerForm"
      (ngSubmit)="submit()"
      class="max-w-4xl mx-auto"
    >
      <!-- Company Information Section -->
      <div class="mb-4">
        <h3
          class="text-lg font-semibold text-gray-700 mb-4 pb-2 border-b border-gray-200"
        >
          {{ "GENERALS.COMPANY-INFO" | translate }}
        </h3>

        <div class="field-grid">
          <!-- Company Name -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "LABEL.COMPANY-NAME" | translate }}</mat-label>
            <input matInput formControlName="company_name" maxlength="191" />
            <mat-error [formControlError]="'company_name'"> </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- User Information Section -->
      <div class="mb-4" formGroupName="user">
        <h3
          class="text-lg font-semibold text-gray-700 mb-4 pb-2 border-b border-gray-200"
        >
          {{ "GENERALS.ACCOUNT-INFO" | translate }}
        </h3>

        <div class="field-grid">
          <!-- First Name -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "LABEL.FIRST-NAME" | translate }}</mat-label>
            <input matInput formControlName="first_name" maxlength="128" />
            <mat-error [formControlError]="'first_name'"> </mat-error>
          </mat-form-field>

          <!-- Last Name -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "LABEL.LAST-NAME" | translate }}</mat-label>
            <input matInput formControlName="last_name" maxlength="128" />
            <mat-error [formControlError]="'last_name'"> </mat-error>
          </mat-form-field>

          <!-- Email -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "LABEL.EMAIL" | translate }}</mat-label>
            <input
              matInput
              type="email"
              formControlName="email"
              maxlength="128"
            />
            <mat-error [formControlError]="'email'"> </mat-error>
          </mat-form-field>

          <mat-form-field class="phone-field w-full">
            <mat-label>
              {{ "LABEL.PHONE-NUMBER" | translate }}
            </mat-label>
            <ngx-mat-input-tel
              [enablePlaceholder]="true"
              [enableSearch]="true"
              formControlName="phone_number"
              name="phone_number"
              describedBy="phoneInput"
              [format]="'national'"
              [required]="true"
              #phone
              maxLength="20"
              (countryChanged)="
                providerForm.controls.user.controls.phone_prefix.setValue(
                  '+' + $event.dialCode
                )
              "
            ></ngx-mat-input-tel>
            <mat-error formControlError="phone_number"></mat-error>
          </mat-form-field>

          <!-- Company Position (Optional) -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ "LABEL.POSITION-IN-COMPANY" | translate }}</mat-label>
            <input
              matInput
              formControlName="company_position"
              maxlength="128"
            />
            <mat-hint>Optional</mat-hint>
            <mat-error [formControlError]="'company_position'"> </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-footer">
    <button
      type="button"
      (click)="submit()"
      class="btn orange-bg w-full md:w-auto disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ "GENERALS.CONFIRM" | translate }}
    </button>
  </div>
</div>
